// eslint-disable-next-line import/prefer-default-export
export const setValuationInfo = (state, action) => ({
  ...state,
  valuationInfo: {
    ...state.valuationInfo,
    ...action.valuationInfo
  }
});
